var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "verify-ach-dialog" }, [
    _c("header", { staticClass: "verify-heading" }, [
      _c(
        "span",
        { staticClass: "verify-icon", attrs: { "aria-hidden": "true" } },
        [_c("portal-icon", { attrs: { name: "circle-check", size: 21 } })],
        1
      ),
      _c("h2", [
        _vm._v(_vm._s(_vm.$t("invoices.verify-ach-account.enter-verification")))
      ]),
      _c(
        "button",
        {
          staticClass: "dialog-close",
          attrs: { type: "button", "aria-label": _vm.$t("global.close") },
          on: { click: _vm.handleClose }
        },
        [_c("portal-icon", { attrs: { name: "x", size: 19 } })],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "verify-body" },
      [
        _c(
          "v-form",
          {
            ref: "accountForm",
            staticClass: "deposit-grid",
            on: {
              submit: function($event) {
                $event.preventDefault()
              }
            },
            model: {
              value: _vm.isValid,
              callback: function($$v) {
                _vm.isValid = $$v
              },
              expression: "isValid"
            }
          },
          [
            _c("v-text-field", {
              staticClass: "portal-form-field",
              attrs: {
                label: _vm.$t("invoices.verify-ach-account.enter-deposit-1"),
                "hide-details": "",
                maxlength: "2",
                prefix: "$0.",
                rules: _vm.requiredRules,
                "persistent-placeholder": ""
              },
              model: {
                value: _vm.amount1,
                callback: function($$v) {
                  _vm.amount1 = $$v
                },
                expression: "amount1"
              }
            }),
            _c("v-text-field", {
              staticClass: "portal-form-field",
              attrs: {
                label: _vm.$t("invoices.verify-ach-account.enter-deposit-2"),
                "hide-details": "",
                maxlength: "2",
                prefix: "$0.",
                rules: _vm.requiredRules,
                "persistent-placeholder": ""
              },
              model: {
                value: _vm.amount2,
                callback: function($$v) {
                  _vm.amount2 = $$v
                },
                expression: "amount2"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _c("footer", { staticClass: "verify-footer" }, [
      _c(
        "button",
        {
          staticClass: "dialog-action outline",
          attrs: { type: "button" },
          on: { click: _vm.handleClose }
        },
        [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
      ),
      _c(
        "button",
        {
          staticClass: "dialog-action primary",
          attrs: { type: "button", disabled: !_vm.isValid },
          on: { click: _vm.verifyAccount }
        },
        [_vm._v(" " + _vm._s(_vm.$t("global.verify")) + " ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }